/**
 * @generated SignedSource<<34259fa5f216382305ef1bff0035a85c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
export type organizationpermission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
export type resource_group_permission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TeamView_organization$data = {
  readonly id: string;
  readonly users: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string | null;
        readonly email: string;
        readonly expiry: string | null;
        readonly firstName: string | null;
        readonly id: string;
        readonly lastName: string | null;
        readonly loginTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly authEnabled: boolean;
              readonly identityProviderConfiguration: {
                readonly id: string;
                readonly name: string;
                readonly providerType: identityprovidertype;
                readonly uuid: string;
              } | null;
              readonly loginType: login_type;
            } | null;
          } | null>;
        } | null;
        readonly loginTypesOverriden: boolean | null;
        readonly organizationPermission: organizationpermission;
        readonly phoneNumber: string | null;
        readonly resourceGroupLinks: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly resourceGroupId: string;
              readonly resourceGroupName: string | null;
              readonly resourceGroupPermission: resource_group_permission;
            } | null;
          } | null>;
        } | null;
        readonly supportedLoginOptions: ReadonlyArray<{
          readonly identityProviderConfiguration: {
            readonly name: string;
            readonly providerType: identityprovidertype;
          } | null;
          readonly loginType: login_type;
        } | null> | null;
        readonly uuid: string;
        readonly " $fragmentSpreads": FragmentRefs<"UserProfile_loginTypes">;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "TeamView_organization";
};
export type TeamView_organization$key = {
  readonly " $data"?: TeamView_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamView_organization">;
};

import TeamRefetchQuery_graphql from './TeamRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "users"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerType",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "loginOverriden"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "loginTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "resourceGroupIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "resourceGroupPermissions"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "role"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uuid"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": TeamRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "TeamView_organization",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "users",
      "args": [
        {
          "kind": "Variable",
          "name": "loginOverriden",
          "variableName": "loginOverriden"
        },
        {
          "kind": "Variable",
          "name": "loginTypes",
          "variableName": "loginTypes"
        },
        {
          "kind": "Variable",
          "name": "resourceGroupIds",
          "variableName": "resourceGroupIds"
        },
        {
          "kind": "Variable",
          "name": "resourceGroupPermissions",
          "variableName": "resourceGroupPermissions"
        },
        {
          "kind": "Variable",
          "name": "role",
          "variableName": "role"
        },
        {
          "kind": "Variable",
          "name": "uuid",
          "variableName": "uuid"
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "__TeamView_users_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiry",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizationPermission",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LoginTypes",
                  "kind": "LinkedField",
                  "name": "supportedLoginOptions",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IdentityProviderConfiguration",
                      "kind": "LinkedField",
                      "name": "identityProviderConfiguration",
                      "plural": false,
                      "selections": [
                        (v4/*: any*/),
                        (v5/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LoginTypesConnection",
                  "kind": "LinkedField",
                  "name": "loginTypes",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoginTypesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LoginTypes",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "authEnabled",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "IdentityProviderConfiguration",
                              "kind": "LinkedField",
                              "name": "identityProviderConfiguration",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v4/*: any*/),
                                (v5/*: any*/),
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserProfile_loginTypes"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "loginTypesOverriden",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserResourceGroupLinkConnection",
                  "kind": "LinkedField",
                  "name": "resourceGroupLinks",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserResourceGroupLinkEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserResourceGroupLink",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resourceGroupId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resourceGroupName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resourceGroupPermission",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "7b0ec6522b006ae4207f063e954ada9b";

export default node;
